import { ButtonList } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import { Channel } from 'lib-shared-types-channels';
import { useState } from 'react';

import {
  UnbanUserModal,
  UnbanUserModalOnCloseEvent,
} from 'components/shared/unbanUserModal/unbanUserModal';
import { UnbanUserResponse } from 'hooks/useBans/types';
import { channelAttributes } from 'utils/channels';

export function UnbanUserButtonListItem(props: {
  user: User;
  channel: Channel;
  onModalOpen?: VoidFunction;
  onUnban?: (response: UnbanUserResponse) => void;
}) {
  const [isModalOpen, setModalOpen] = useState(false);
  const { user, channel, onUnban, onModalOpen } = props;

  function handleOnModalClose(event: UnbanUserModalOnCloseEvent) {
    setModalOpen(false);

    if (!event.canceled && event.response && onUnban) {
      onUnban(event.response);
    }
  }

  function handleOnModalOpen() {
    setModalOpen(true);
    onModalOpen && onModalOpen();
  }

  return (
    <>
      <ButtonList.Item icon="undo" onClick={handleOnModalOpen}>
        Unban from {channelAttributes[channel]?.name ?? 'Unknown'}
      </ButtonList.Item>
      <UnbanUserModal
        user={user}
        channel={channel}
        isOpen={isModalOpen}
        onClose={handleOnModalClose}
      />
    </>
  );
}
